import { defineStore } from "pinia";
import axios from "axios";
import { Preferences } from "@capacitor/preferences";

export const useUserStore = defineStore("user", {
state: () => ({
  user: null,
  token: null,
  refreshToken: null,
  mvCoins: 0,
  direcciones: [],
  isAuthenticated: false,
    isSessionReady: false,
}),



  actions: {
    // Guardar usuario en Pinia y localStorage
    setUser(userData) {
      this.user = userData;
      localStorage.setItem("user", JSON.stringify(userData));
    },

    // Obtener MV Coins
    async obtenerMVCoins() {
      if (!this.user || !this.user.id) return;

      try {
        const response = await axios.get(
          `https://mvexpress.mx/api/get-mvcoins/${this.user.id}`,
          { headers: { Authorization: `Bearer ${this.user.token}` } }
        );
        this.user = { ...this.user, ...response.data };
        this.mvCoins = parseFloat(response.data.mvCoins || 0);
        localStorage.setItem("user", JSON.stringify(this.user));
      } catch (error) {
        console.error("Error al obtener MV Coins:", error);
      }
    },

    // Obtener direcciones
    async obtenerDirecciones() {
      if (!this.user || !this.user.cliente) {
        console.warn("Usuario no logueado, redirigiendo a login...");
        return null;
      }

      const cacheKey = `direcciones_${this.user.cliente}`;
      const cacheTimeKey = `${cacheKey}_timestamp`;
      const now = Date.now();
      const oneWeek = 7 * 24 * 60 * 60 * 1000;

      const cachedData = localStorage.getItem(cacheKey);
      const cachedTime = localStorage.getItem(cacheTimeKey);

      if (cachedData && cachedTime && now - cachedTime < oneWeek) {
        this.direcciones = JSON.parse(cachedData);
        return this.direcciones;
      }

      try {
        const response = await axios.get(
          `https://mvexpress.mx/api/find-direccion/${this.user.cliente}`,
          { headers: { Authorization: `Bearer ${this.user.token}` } }
        );

        this.direcciones = response.data.filter(
          (dir, index, self) =>
            index === self.findIndex((d) => d.CTEDIR_CODIGO_K === dir.CTEDIR_CODIGO_K)
        );

        const jsonData = JSON.stringify(this.direcciones);
        if (jsonData.length < 4 * 1024 * 1024) {
          localStorage.setItem(cacheKey, jsonData);
          localStorage.setItem(cacheTimeKey, now);
        }

        return this.direcciones;
      } catch (error) {
        console.error("Error al obtener direcciones:", error);
        return null;
      }
    },
 async obtenerNuevaData() {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.id) return;

      const response = await axios.get(`https://mvexpress.mx/api/get-mvcoins/${user.id}`);
      this.user = response.data; // o actualiza userStore.user
    } catch (err) {
      console.error(err);
    }
  },
async login(email, password) {
  const { data } = await axios.post("https://mvexpress.mx/api/auth", {
    email,
    password,
  });

  this.token = data.token;
  this.refreshToken = data.refreshToken;
  this.isAuthenticated = true;

  this.user = {
    id: data.id,
    cliente: data.cliente,
    email: data.email,
    usuario: data.usuario,
    razon: data.razon,
    rfc: data.rfc,
    telefono: data.telefono,
    mvCoins: data.mvCoins,
    forma_pago: data.forma_pago,
    uso_cfdi: data.uso_cfdi,
    denominacion_comercial: data.denominacion_comercial,
    ruta_preventa: data.ruta_preventa,
    ruta_reparto: data.ruta_reparto,
    politica_privacidad_aceptada: data.politica_privacidad_aceptada,
    fecha_politica_privacidad: data.fecha_politica_privacidad,
  };

  this.direcciones = data.direcciones || [];

  await Preferences.set({
    key: "auth_session",
    value: JSON.stringify({
      token: data.token,
      refreshToken: data.refreshToken,
      user: this.user,
      direcciones: this.direcciones,
    }),
  });

  axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
},


async initSession() {
  console.log("🟢 initSession() INICIO");

  if (this.isSessionReady) {
    console.log("⚠️ sesión ya lista, saliendo");
    return;
  }

  const { value } = await Preferences.get({ key: "auth_session" });
  //console.log("📦 auth_session =", value);

  if (!value) {
    console.log("❌ NO hay sesión guardada");
    this.isSessionReady = true;
    return;
  }

  const session = JSON.parse(value);

  this.token = session.token;
  this.refreshToken = session.refreshToken;
  this.user = session.user;
  this.direcciones = session.direcciones || [];
  this.isAuthenticated = true;

  console.log("✅ SESIÓN CARGADA CORRECTAMENTE");

  axios.defaults.headers.common.Authorization = `Bearer ${session.token}`;
  this.isSessionReady = true;
},



    // Cerrar sesión
async logout() {
  // Limpiar store
  this.user = null;
  this.token = null;
  this.refreshToken = null;
  this.direcciones = [];
  this.isAuthenticated = false;
  this.isSessionReady = true;

  // Vaciar session en storage
  await Preferences.set({ key: "auth_session", value: JSON.stringify({}) });
}


  },
});
